export default __webpack_public_path__ + "static/media/star.1f9ff90a.png";